// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__17E6S","options":"Select_options__10Zf-","item":"Select_item__1oRxj"};